import { ff, getFeatureFlagValue } from '@atlassian/jira-feature-flagging';

export const getEnableFlexibleBlockCardInIssueEditor = () =>
	ff('issue.details.editor.enable-flexible-block-card');

export const getTTRSeverityTrackingConfiguration = () =>
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	getFeatureFlagValue<any>('issue.details.renderer.ttr-severity-tracking', {});

export const getUnsupportedContentLevelsTrackingConfiguration = () =>
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	getFeatureFlagValue<any>('issue.details.renderer.unsupported-content-levels-tracking', {});

export const isSpecBasedValidatorEnabled = () => ff('issue.details.renderer.spec-based-validator');

export const isRendererTtiTrackingEnabled = (): boolean =>
	ff('issue.details.renderer.tti-tracking', false);

export const isAltTextOnImagesEnabled = () => ff('editor.renderer-alt-text-on-images', false);

export const isMediaInlineEnabled = () => ff('issue.details.media-inline', false);
